<script>
export default {
  computed: {
    currentCoins() {
      return this.$route.query.coins || 0;
    }
  },
  methods: {
    goToTerms(){
      this.$router.push('/terms');
    },
    home() {
      const coins = this.currentCoins;

      this.$store.commit('setRegularGameCoins', parseInt(coins));
      this.$router.go(-2);
    }
  }
}

</script>

<template>


<div class = "containerBg">
  <div class = "d-flex justify-content-center align-items-center ">
    <img src = "@/assets/upsell/yello-rush-upsell.png" class = "col-6 mt-5"  />
  </div>

  <div class = "d-flex justify-content-center align-items-center bold mt-5 ">Thank you! You have successfully </div>
  <div class = "d-flex justify-content-center align-items-center bold">subscribed to Y’ello Rush </div>

  <div class = "d-flex justify-content-center align-items-center normalText mt-3">R5/day. Subscription service</div>
  <div class = "d-flex justify-content-center align-items-center normalText">FIRST DAY FREE</div>

  <div class="row ">
    <div class="d-flex justify-content-center text-center mt-5">
      <div class="yellowButton playText p-3 col-11 yes" @click = home>Return to Mzansi Rhythm</div>
    </div>
  </div>

  <div class="row ">
    <div class="d-flex justify-content-center text-center mt-3">
      <div class=" p-3 col-11 blackButton open ">Open Y’ello Rush</div>
    </div>
  </div>


  <div class ="d-flex flex-column col-12 tcs">
    <div class = "d-flex justify-content-center align-items-center normalText mt-3 ">R5/day. Subscription service. </div>
    <div class = "d-flex justify-content-center align-items-center texttcs " @click = goToTerms>Terms and Conditions  </div>
  </div>



</div>

</template>

<style scoped>

.containerBg {
  position: relative;
  min-height: 100vh ;
  min-width: 100vw;
  background-image: url('@/assets/upsell/upsell-bg.png');
  background-size: cover;
  padding-top: 21%
}

.yes{
  font-weight: 600;
  font-size: 19px;
}
.open{
  font-weight: 600;
  font-size: 19px;
  color: #FFFFFF;
}

.yellowButton{
  background-color: #FFCB05;
  border-radius: 23px;
}

.blackButton{
  background-color: #000000;
  border-radius: 23px;
}


.texttcs{
  text-decoration: underline;
  color: #007AFF;
  font-weight: 400;
  font-size: 15px;
}

.tcs{
  position: absolute;
  bottom: 5%;
}

.bold{
  font-weight: 600;
  font-size: 17px;
  color: #000F56;
}

.normalText{
  font-weight: 400;
  font-size: 15px;
  color: #000F56;
}
</style>